import { QueryClient } from "@tanstack/react-query";
import { ApiError } from "./api/base";

/** Dispatch a custom event when a 401 is detected, so AuthContext can handle logout */
function handle401(error: unknown) {
	if (error instanceof ApiError && error.status === 401) {
		window.dispatchEvent(new CustomEvent("auth:session-expired"));
	}
}

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 1000 * 60 * 5, // 5 minutes - data fresh for 5 min
			gcTime: 1000 * 60 * 30, // 30 minutes (cache garbage collection)
			retry: (failureCount, error) => {
				// Don't retry on auth errors (401/403)
				if (error instanceof ApiError && [401, 403].includes(error.status)) {
					return false;
				}
				// Retry up to 2 times for network/server errors
				return failureCount < 2;
			},
			refetchOnWindowFocus: true, // Refresh data when user returns to tab
			refetchOnReconnect: true, // Refresh when internet reconnects
		},
		mutations: {
			retry: false, // Never retry mutations by default
			onError: (error) => {
				console.error("Mutation error:", error);
				handle401(error);
			},
		},
	},
});

// Global query error handler for 401 detection
queryClient.getQueryCache().config.onError = (error) => {
	handle401(error);
};
